import { useState } from "react"
import axios from "axios";
const LoginForm = () => {
    const [username, setusername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async(e) => {
        e.preventDefault();

        const authObject ={'Project-ID': '8f16984c-2126-4643-8f05-aec17520ab06', 'User-Name':username, 'User-Secret':password}
        
        try {
            await axios.get('https://api.chatengine.io/chats', {headers: authObject});
            localStorage.setItem('username' , username);
            localStorage.setItem('password' , password);
            window.location.reload();
            
        } catch (error) {
            setError(' incorrect data');
        }

    }

    return (
        <div className="wrapper">
            <div className="form">
                <h1 className="title"> Chat Application</h1>
                <form onSubmit={handleSubmit}>
                    <input className="input"
                        placeholder="username" required
                        type='text'
                        value={username}
                        onChange={(e) => setusername(e.target.value)}
                    />

                    <input className="input"
                        placeholder="Password" required
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <div align="center">
                        <button type="submit" className="button">
                            <span>Start Chatting</span>
                        </button>

                    </div>
                    <h2 className="error">{error}</h2>
                </form>
            </div>

        </div>
    )


}

export default LoginForm;